/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import BossDialog from "../../components/BossDialog";
import { Form, FormElement } from "@progress/kendo-react-form";
import * as API from "../../framework/API/api"
import { BUCKET_CONFIG_TYPE, ENTITYNAME, LOGEVENT, MODULE } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import { Description } from "@mui/icons-material";
import { TimePickerWithFormat } from "../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import moment from "moment";


export const PriceCodeEditForm = (props) => {

  const lang = useTranslation();
  const blankDataItem = {
    ...props?.item,
    SID: props?.item?.SID ?? 0,
    Description: props?.item?.copy ? 'copy of ' + props?.item?.Description : props?.item?.Description ?? '',
    Code: props?.item?.Code ?? '',
    Price: props?.item?.Price ?? '',
    Currency: props?.item?.Currency ?? {},
    Days: props?.item?.Days ?? 0,
    Archive: props?.item?.Archive ?? false,
    Duration: props?.item?.Duration ? utility.convertMilisecondsToStringWithFrames(props?.item?.Duration) : "00:00:00:00",
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [currency, setCurrency] = useState([]);

  useEffect(() => {
    loadcombo();
  }, [])

  const loadcombo = async () => {
    var currencyRes = await API.getDataLookup(ENTITYNAME.Currency, { sort: { Description: 1 } });
    setCurrency(currencyRes.data);
  }
  //function to check the validation in form
  function validationCheck() {

    if (dataItem.Description == undefined || dataItem.Description.trim().length == 0 || dataItem.Description == "") {
      toast.error(`${lang.please_enter_description_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (dataItem.Code == undefined || dataItem.Code.trim().length == 0 || dataItem.Code == "") {
      toast.error(`${lang.please_enter_code_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (dataItem.Price == undefined || dataItem.Price.trim().length == 0 || dataItem.Price == "") {
      toast.error(`${lang.please_enter_currency_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    return true;
  }

  const handleSubmit = async (e) => {

    if (validationCheck()) {
      const saveData = {
        _id: dataItem?._id,
        SID: dataItem?.SID ?? 0,
        Description: dataItem?.Description,
        Code: dataItem?.Code,
        Price: dataItem?.Price,
        Currency: dataItem?.Currency && Object.keys(dataItem?.Currency).length > 0 ? {
          _id: dataItem?.Currency?._id,
          Description: dataItem?.Currency?.Description,
          IsDefault: dataItem?.Currency?.IsDefault
        } : {},
        Days: dataItem?.Days,
        Archive: dataItem?.Archive ?? false,
        Duration: dataItem?.Duration && utility.convertStringWithFramesToMilliseconds(dataItem?.Duration),
      }
      console.log(saveData);

      let res = await API.saveData(ENTITYNAME.PRICECODE, saveData);
      if (res.success) {
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.PRICE_CODE, data: res.data, message: res.message };
        API.SaveLogs(logData);
        utility.deleteLocalStorageItem(ENTITYNAME.PRICECODE);
        props.cancelEdit();
        props.refresh();
      }
      else {
        toast.error(res.message, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    }
  }

  const onChangeForm = (e) => {

    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

  }

  return (
    <BossDialog
      title={props.item.SID > 0 ? props.item.Description : "Create Price Code"}
      onClose={props.cancelEdit}
      width={"770px"}
    >
      <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
      <Form
        initialValues={dataItem}
        render={(formRenderProps) => (
          <FormElement>
            <div className="row mt-2">
              <div className="col-12">
                <div className="row">
                  <div className="col-6">
                    <label>{lang.description_label} *</label>
                    <input
                      name={"Description"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Description}
                    />
                  </div>
                  <div className="col-6">
                    <label>{lang.code_label} *</label>
                    <input
                      name={"Code"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Code}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-6">
                    <label>{lang.price_label} *</label>
                    <input
                      name={"Price"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Price}
                    />
                  </div>
                  <div className="col-6" >
                    <label>{lang.currency_label}</label>
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={currency}
                      name="Currency"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.Currency}
                      onChange={onChangeForm}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-6" >
                    <label>{lang.days_label}</label>
                    <input
                      name="Days"
                      className="form-control form-control-sm"
                      value={dataItem.Days}
                      type="number"
                      onChange={onChangeForm}
                      min={0}
                    />
                  </div>
                  <div className="col-6">
                    <label>{lang.duration_label}</label><br />
                    <TimePickerWithFormat className="form-control form-control-sm" name="Duration" value={dataItem.Duration} onChange={onChangeForm} />
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-6" >
                    <input type={"checkbox"} name={"Archive"}
                      onChange={(e) => onChangeForm(e)}
                      value={dataItem.Archive}
                      checked={dataItem.Archive} />
                    <label className="ml-1">{lang.archive}</label>
                  </div>
                </div>
              </div>
            </div>
          </FormElement>
        )}
      />

    </BossDialog>)
};